import { UseMutationOptions } from "@tanstack/react-query"
import { AxiosError } from "axios"

import type { ResponseConfig } from "~/backend/axiosClient"
import { queryClient } from "~/backend/queryClient"
import {
  findMappingByTypeQueryKey,
  findPendingMappingQueryKey,
  useCreateMappingElement,
} from "~/gen/api/hooks"
import { CreateMappingElementRequestDto } from "~/gen/api/types"
import { showAxiosError } from "~/utils/showAxiosError"
import { showSuccessNotification } from "~/utils/showSuccessNotification"

export const useCreateMappingElementMutation = (
  queryParams: { page: number },
  options?: UseMutationOptions<
    ResponseConfig<boolean>,
    unknown,
    { data: CreateMappingElementRequestDto }
  >
) =>
  useCreateMappingElement({
    mutation: {
      ...options,
      onSuccess: async (_, variables) => {
        await queryClient.invalidateQueries({
          queryKey: findMappingByTypeQueryKey(variables.data.type, queryParams),
        })
        await queryClient.invalidateQueries({
          queryKey: findPendingMappingQueryKey(),
        })
        showSuccessNotification({
          title: "Created",
          message: ` mapping has been created`,
        })
      },
      onError: (error) => {
        if (error instanceof AxiosError) {
          showAxiosError({
            notificationTitle: "Error",
            showNotification: true,
            error: error as Error,
          })
        }
      },
    },
  })
